/*inicio constantes de cupon de descuento*/
  const btnCoupon = document.getElementById("btn-coupon");
  const alertCoupon = document.getElementById("alert-coupon");
  const alertSuccessCoupon = document.getElementById("alert-success");
  const couponsApplied = document.getElementById("coupons-applied");
  const inputCoupon = document.getElementById("coupon-code");
  const informationItemsCart = document.getElementsByClassName('ctn-cart-item');
  const btnSaveCheckoutFileCart = document.getElementById('btn-save-checkout');
  const itemsCartSummaryPopup2 = document.getElementById('items-cart-pop-up');
  const priceWithDiscountCartPopUp2 = document.getElementById('price-with-discount-cart-pop-up');
  const priceWithoutDiscountCartPopUp2 = document.getElementById('price-without-discount-cart-pop-up');
/*fin constantes de cupon de descuento*/

const btnPago = document.getElementById('pagarPedido');

/*inicio variables de cupon de descuento*/
  let couponObjectInfo = {};
  let discount = 0
  let dateNow = new Date(); 
  let btnCancel = "";
/*fin variables de cupon de descuento*/

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));
    this.addCoupon(btnCoupon);
    this.createCouponBox("Save", {});    
  }

  getFormatForCountry = (value, country) => {
    let valueReturn = "";
    switch (country) { 
      case "CO":
        valueReturn = "$ " + this.formatMoneyCart(value, "amount");
        break;
    }    
    return valueReturn;
  }

  formatWithDelimiters = (number, precision, thousands, decimal) => {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  formatMoneyCart = (cents, format) => {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format;

    return this.formatWithDelimiters(cents, 2);
  }

  structureItemsPopUp = (items) => {
    let structure = "";
    for(let i = 0; i < items.length; i++){
      structure += '<div class="item-cart-summary-popup"><div class="image-cart-summary-popup"><img src="'+
        items[i].featured_image.url+'"/></div><div class="info-item-cart-summary-popup"><p class="vendor-item-cart-pop-up">'+
        items[i].vendor+'</p><span class="title-item-cart-pop-up">'+
        items[i].title+'</span><span class="price-item-cart-pop-up">'+
        this.getFormatForCountry(items[i].price, metafieldCurrentCountry)+'</span><span class="variant-item-cart-pop-up">Talla: '+
        items[i].variant_options[0]+'</span><span class="cant-item-cart-pop-up">Cant: '+
        items[i].quantity+'</span></div></div>'
    }
    return structure
  }

  showSummaryModal = async (currentCart) => {
    itemsCartSummaryPopup2.innerHTML = this.structureItemsPopUp(currentCart.items);
    priceWithDiscountCartPopUp2.innerHTML = this.getFormatForCountry(currentCart.total_price, metafieldCurrentCountry); 
    priceWithoutDiscountCartPopUp2.innerHTML = currentCart.total_discount > 0 ? this.getFormatForCountry(currentCart.original_total_price, metafieldCurrentCountry): "";
  }

  addCoupon = (btnCoupon) => {
    btnCoupon?.addEventListener("click", (event) => {
      this.fileCoupons(true);
      alertCoupon.style.display = "none";
    })
  }

  fileCoupons = async (clickAction = false) => {
    try{
      const responseFileCoupons = await fetch("https://cdn.shopify.com/s/files/1/0679/9133/9145/files/CuponesDescuento20_6d432d54-5aac-4b3d-9df2-b8878922d2c9.csv?v=1748621588");
      const dataFileCoupons = await responseFileCoupons.text();
      const allRows = dataFileCoupons.split(/\r?\n|\r/);

      let productsOrCollectionApplied = [];

      const currentCart = await this.getCart();
      if(clickAction && currentCart.attributes.cupon_cart === quitarAcentos(inputCoupon?.value)) return;
      if(clickAction && !quitarAcentos(inputCoupon?.value)) return;
      for (let singleRow = 0; singleRow < allRows?.length; singleRow++) {
        let rowCells = allRows[singleRow].split(';');
        // if(rowCells[0] !== '' && (quitarAcentos(rowCells[0]) === quitarAcentos(inputCoupon?.value))){
        if(rowCells[0] !== '' && ((quitarAcentos(rowCells[0]) === quitarAcentos(inputCoupon?.value) && clickAction)  || (quitarAcentos(rowCells[0]) === currentCart.attributes.cupon_cart) && !clickAction)){
          if(rowCells[1] === "descuentoenproducto"){
            productsOrCollectionApplied = rowCells[6] != ""?rowCells[6]?.split(','):[];
            productsOrCollectionApplied = productsOrCollectionApplied?.map(Number);            
          }      
        
          couponObjectInfo = {
            coupon_type: rowCells[1],
            code_coupon: rowCells[0],
            type_discount: rowCells[2],
            discount_amount: rowCells[3],
            apply_discount_by_order: rowCells[4],
            applied_type: rowCells[5],
            requirement_type: rowCells[7],
            requirement_amount: rowCells[8],
            date_start: rowCells[9],
            date_end: rowCells[10],
            applied_products: productsOrCollectionApplied
          }
        }
      }
        
      if(Object.entries(couponObjectInfo).length > 0){
        this.codeVerification(couponObjectInfo);
      } else {
        await this.deleteCuponInCheckout("");
        if(clickAction){
          alertCoupon.style.display = "flex";
          setTimeout(() =>{
            alertCoupon.style.display = "none";
          }, 3000)
        }
      }
    } catch(err){
      console.log(err);
    }      
  }
  convertToISO(date) {
    // Asume el formato dd/mm/yyyy hh:mm[:ss]
    const [day, month, yearAndTime] = date.split('/');
    const [year, time] = yearAndTime.split(' ');

    if (!time) {
      // Si no hay tiempo, devuelve una fecha predeterminada con hora 00:00:00
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00` 
    }

    // Verifica si hay segundos en la cadena de entrada
    const [timePart, seconds = '00'] = time.split(':');
    const [hour, minute] = timePart.split(':');

    // Asegúrate de que el día y el mes tengan dos dígitos
    const paddedDay = day.padStart(2, '0');
    const paddedMonth = month.padStart(2, '0');

    // Asegúrate de que la hora, minuto y segundos tengan dos dígitos
    const paddedHour = (hour || '00').padStart(2, '0');
    const paddedMinute = (minute || '00').padStart(2, '0');
    const paddedSeconds = (seconds || '00').padStart(2, '0');
    
    // Formato ISO
    return `${year}-${paddedMonth}-${paddedDay}T${paddedHour}:${paddedMinute}:${paddedSeconds}`;
  }

  validateDate = (type, date) => {
    let formatDate = new Date(this.convertToISO(date)).getTime();
    let formatDateNow = dateNow.getTime();
    let yearDate =  new Date(this.convertToISO(date)).getFullYear();
    let yearDateNow =  dateNow.getFullYear();
    
    if(type == "date_end"){
      if(formatDateNow < formatDate && yearDateNow <= yearDate){
        return true;
      }else{
        return false;
      }
    }else if(type == "date_start"){
      if(formatDateNow > formatDate && yearDateNow >= yearDate){
        return true;
      }else{
        return false;
      }  
    }    
  }

  getCart = async () =>{
    const responseCart = await fetch("/cart.json");
    return await responseCart.json();
  }

  formatValuePrices = (price) => {
    return price / 100
  }

  requirementCoupon = async (couponObjectInfo) => {
    const currentCart = await this.getCart();
    switch (couponObjectInfo?.requirement_type) {
      case "montoMinimo": 
        if(this.formatValuePrices(currentCart?.original_total_price) >= parseInt(couponObjectInfo?.requirement_amount)){
          return true;
        }
        break;
      case "cantidadMinima": 
        if(currentCart?.item_count >= parseInt(couponObjectInfo?.requirement_amount)){
           return true;
        }
        break;
      case "productsWithoutDiscount": 
        let itemsCart = currentCart.items;
        let countItemWithDiscount = 0;
        for(let i = 0 ; i < informationItemsCart.length; i++){
          let compare_at_price = parseInt(informationItemsCart[i]?.dataset.compareAtPrice) / 100;
          let id_variant = parseInt(informationItemsCart[i]?.dataset.variantId);
          if(itemsCart.find(element => element.variant_id == id_variant) !== undefined){
            if(compare_at_price > (itemsCart.find(element => element.variant_id == id_variant)?.price / 100)){
              countItemWithDiscount += 1;
            }
          }
          
        }

        alertCoupon.innerHTML = "No aplica el codigo de descuento para esta compra";
        if(countItemWithDiscount == 0){
          await this.deleteCuponInCheckout("");
          return true;
        }else{
          await this.deleteCuponInCheckout(couponObjectInfo?.code_coupon);
        }
        
        break;
      case "":
        return true;
        break;
    }
    return false;
  }

  createCouponBox = async (type, couponObjectInfo) => {

    if(document.getElementById("coupon-one") != undefined && document.getElementById("coupon-one") != null){
      let couponApplied = document.getElementById("coupon-one");
      if (couponApplied) { 
        couponApplied.parentNode.removeChild(couponApplied); 
      }
    }
    
    const couponBox = document.createElement("div");
    const couponName = document.createElement("div");
    const couponClose = document.createElement("div");
    

    couponBox.setAttribute("id", "coupon-one");
    
    couponBox.setAttribute("class", "coupon");

    couponName.setAttribute("id", "name-coupon-applied");

    couponClose.setAttribute("id", "cancel-dto");


    if(type == "Applied"){
      await this.addOrDeleteCoupon(couponObjectInfo?.code_coupon) 
      alertSuccessCoupon.style.display = 'flex';
      alertCoupon.style.display = "none"; 

      setTimeout(()=>{
        alertSuccessCoupon.style.display = 'none'
      }, 5000)
      
      couponsApplied?.append(couponBox);  
    
      couponBox?.append(couponName); 
      
      couponBox?.append(couponClose);

      document.getElementById("name-coupon-applied")?.append(couponObjectInfo?.code_coupon);
    }else if(type == "Save"){
      const currentCart = await this.getCart();
      
      if(currentCart.attributes.cupon_cart != undefined && currentCart.attributes.cupon_cart != ""){ 
        
        couponsApplied?.append(couponBox);  
    
        couponBox?.append(couponName); 
        
        couponBox?.append(couponClose);

        document.getElementById("name-coupon-applied")?.append(currentCart.attributes.cupon_cart);
        
        alertCoupon.style.display = "none";
      }
    }
    
    document.getElementById("cancel-dto")?.append("X");

    btnCancel = document.getElementById("cancel-dto");

    inputCoupon.value = "";
    
    await this.removeCoupon();
  }

  deleteCuponInCheckout = async (valueDiscountRemove) => {
    const responsePostCart = await fetch("/cart/update.js", { method: "POST", headers: {'X-Requested-With': 'XMLHttpRequest','Content-Type': 'application/json;'},  body: JSON.stringify({attributes: {coupon_remove: valueDiscountRemove}})});
    btnSaveCheckoutFileCart.setAttribute("data-coupon-remove",valueDiscountRemove);
    return responsePostCart;
  }

  addOrDeleteCoupon = async (valueDiscount) => {
    const responsePostCart = await fetch("/cart/update.js", { method: "POST", headers: {'X-Requested-With': 'XMLHttpRequest','Content-Type': 'application/json;'},  body: JSON.stringify({attributes: {cupon_cart: valueDiscount}})});
    btnSaveCheckoutFileCart.setAttribute("data-coupon",valueDiscount);
    return responsePostCart;
  }

  removeCoupon = async () => {
    btnCancel?.addEventListener("click", async (event) => {
      event.preventDefault(); 
      document.getElementById("coupon-one").remove();       
      alertCoupon.style.display = "none";
      await this.addOrDeleteCoupon("")
    });
  }

  removeCouponBox = async () => {
    document.getElementById("coupon-one")?.remove(); 
    alertCoupon.style.display = "none";
    await this.addOrDeleteCoupon("")
  }

  validateProduct = async (couponObjectInfo) => {
    const currentCart = await this.getCart();
    const items = currentCart.items;
    const idsProductApplied = couponObjectInfo?.applied_products;
    let cantProductsCorrect = 0;
    let arrayValidateProductCollection = [];
    
    switch (couponObjectInfo?.applied_type) {
      case "colecciones":
        for(let i = 0 ; i < informationItemsCart.length; i++){
          let splitIdsCollection = informationItemsCart[i]?.dataset.idsCollections.split(",");
          for(let j = 0; j < splitIdsCollection.length; j++){
            if(splitIdsCollection[j] != "" && idsProductApplied.find(element => element == parseInt(splitIdsCollection[j])) != undefined){
              arrayValidateProductCollection.push(true);
            }
          }
        }
        
        if(arrayValidateProductCollection.filter(element => element == true)?.length > 0){
          return true;
        }
        
        break;
      case "productos": 
        for(let i = 0; i < items.length; i++){
          if(idsProductApplied.find(element => element == items[i].product_id) != undefined){
            cantProductsCorrect += 1;
          }
        }

        if(cantProductsCorrect > 0){
          return true;
        }
        break;
    }    
    return false;
  }

  codeVerification = async (couponObjectInfo) => {
    let dateStartValidate = false;
    let dateEndValidate = false;
    let requirementValidate = false;
    let productValidation = false;

    if(couponObjectInfo.date_start !== ""){
      dateStartValidate = this.validateDate("date_start",couponObjectInfo.date_start);
    }else{
      dateStartValidate = false;
    }

    if(couponObjectInfo.date_end !== ""){
      dateEndValidate = this.validateDate("date_end",couponObjectInfo.date_end);
    }else{
      dateEndValidate = true;
    }    

    if(dateStartValidate && dateEndValidate){
      if(couponObjectInfo?.coupon_type != "descuentoenproducto"){
        requirementValidate = await this.requirementCoupon(couponObjectInfo);  
      }else{
        if(couponObjectInfo?.applied_products.length > 0){
          productValidation = await this.validateProduct(couponObjectInfo);
          if(couponObjectInfo?.type_discount === 'porcentaje' && ( parseInt(couponObjectInfo?.discount_amount) > 0 || parseInt(couponObjectInfo?.discount_amount) <= 100 ) && productValidation) {
            let discount_rate = parseInt(couponObjectInfo?.discount_amount)/100; 
            requirementValidate = await this.requirementCoupon(couponObjectInfo); 
          }else if(couponObjectInfo?.type_discount === 'monto' && ( parseInt(couponObjectInfo?.discount_amount) > 0 || parseInt(couponObjectInfo?.discount_amount) <= 100 ) && productValidation){
            let discount_amount = parseInt(couponObjectInfo?.discount_amount);    
            requirementValidate = await this.requirementCoupon(couponObjectInfo); 
          } 
        }else{
          requirementValidate = false;  
        }
      }      
      
      if(requirementValidate){
        this.createCouponBox("Applied",couponObjectInfo);
      }else{
        this.removeCouponBox()
        alertCoupon.style.display = "flex";      
      }

    }else{
       alertCoupon.style.display = "flex";
    }
  }

  getDiscountWithCondition = async (products_array = [], discount_value = 0, discount_type, apply_discount_by_order = false) => {
    const currentCart = await this.getCart();
    const items = currentCart.items; 

    let dicountReturn = 0;
    let control_condition = false; 
    
    apply_discount_by_order === 'si' ? apply_discount_by_order = true : apply_discount_by_order = false;

    if(products_array.length > 0){
      items.forEach(item => {
        let line_price = item.line_price/100;
        let quantity = item.quantity;
        if(products_array.includes(item.product_id)) {
          if(discount_type === 'porcentaje'){
            let product_discount = 0;
            let price_with_quantity = line_price * quantity;
            product_discount = price_with_quantity * discount_value;
            dicountReturn = discount + product_discount;        
          } else { // Si es por cada producto: 
             if (apply_discount_by_order === true && control_condition === false) { 
                control_condition = true;
                dicountReturn = discount_value;
              } else if (apply_discount_by_order === false) {
                dicountReturn = discount + (quantity * discount_value);
              }
              // let product_discount = 0;
              // let price_with_quantity = line_price * quantity;
              // discount = discount_value;
          }
        }      
      })
    }
    return dicountReturn; 
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.footer-js-contents',
      },
      {
        id: 'ctn-suggested-collection',
        section: document.getElementById('ctn-suggested-collection').dataset.id,
        selector: '#ctn-suggested-collection',
      },
      // {
      //   id: 'ctn-message-gift',
      //   section: document.getElementById('ctn-message-gift').dataset.id,
      //   selector: '#ctn-message-gift',
      // },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.fileCoupons();
        this.showSummaryModal(parsedState);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');


        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        const cartSection = document.querySelector('.section-cart')
        cartSection.classList.toggle('is-empty', parsedState.item_count === 0); 
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        if(parsedState.items.length == 0){
          const collectionGender = JSON.parse(localStorage.getItem('Collection_gender'));
          if (collectionGender) {
            const ctnCartSuggested = document.querySelector('.container-cart .suggested-collection')
            if(ctnCartSuggested){
              ctnCartSuggested.querySelector('.container-featured-collection').href = collectionGender.url;
              ctnCartSuggested.querySelector('.container-cart .suggested-collection .img-featured-collection').src = collectionGender.img;
              ctnCartSuggested.querySelector('.container-cart .suggested-collection .title-featured-collection').textContent = collectionGender.name;
              document.querySelector('cart-items').classList.add('ctn-cart-empty')
              document.querySelector('.container-cart #ctn-suggested-collection').style.display = 'flex'
              document.querySelector('.container-cart').style.alignItems = 'center'
            }
          }
        }
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`)
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }  
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

 


btnPago.addEventListener('click', async (event) => {
  
  const currentCart = await fetch("/cart.json");
  const dataCurrentCart = await currentCart.json();
  const shopDomain = "https://malva-intl.myshopify.com";
  let cuponDiscount = false;
  let cuponAplicade = "";
  
  if(document.getElementById('name-coupon-applied')){
    console.log("entro aqui")
    cuponAplicade = document.getElementById('name-coupon-applied').textContent;
    cuponDiscount = true;
  }else{
    console.log("entro aqui 2")
    cuponDiscount = false;
  }
  
  let productsArray = "";
  
  getProductInfo = async (handle) => {
    const responseProduct = await fetch(`/products/${handle}.json`);
    return await responseProduct.json();
  }
  
  for(let i = 0; i < dataCurrentCart.items.length; i++){
    let infoProduct = await this.getProductInfo(dataCurrentCart.items[i].handle);
    productsArray = productsArray + dataCurrentCart.items[i].variant_id + ":" + dataCurrentCart.items[i].quantity + ",";
    if((parseInt(infoProduct.product.variants.find(variant => variant.id == dataCurrentCart.items[i].variant_id)?.compare_at_price)) > (parseInt(dataCurrentCart.items[i].price) / 100)){
       countItemsComparePriceHigher += 1;
    }
  }  
  let couponToSend = event.target.dataset.coupon != undefined && event.target.dataset.coupon != ""?event.target.dataset.coupon:"";
  let couponToSendForRemove = event.target.dataset.couponRemove != undefined && event.target.dataset.couponRemove != ""?event.target.dataset.couponRemove:"";
  
  let urlRedirect = shopDomain+"/cart/"+productsArray+"?storefront=false&attributes[coupon_remove]="+couponToSendForRemove+"&discount="+cuponAplicade;
  //console.log("urlRedirect", urlRedirect)
  window.location.href = urlRedirect; 
});
